import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { VrcErrorMsgComponent } from './components/vrc-error-msg/vrc-error-msg.component';
import { SafePipe } from './pipes/safe.pipe';

const exports = [SafePipe, VrcErrorMsgComponent];

@NgModule({
  declarations: [...exports],
  exports,
  imports: [
    CommonModule,
    HttpClientModule
  ],
})
export class VrCommonModule { }
